import { render, staticRenderFns } from "./pot-1-logistic.vue?vue&type=template&id=1bd5903d"
import script from "./pot-1-logistic.vue?vue&type=script&lang=js"
export * from "./pot-1-logistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports